import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
import { Size } from '../../../../Enums/Size.enum';
import styles from './SubscriptionCancellationModal.module.scss';
import Text from '../../../BaseModule/Components/Text';

const SubscriptionSuccessfulCancellationModal: React.FC<
	BaseModalProps
> = props => (
	<BaseModal
		{...props}
		title='component.subscriptionSuccessfulCancellationModal.title'
		size={Size.SM}
	>
		<div className={styles.wrapper}>
			<div className='d-flex flex-column justify-content-center align-items-center gap-4'>
				<Text tx='component.subscriptionSuccessfulCancellationModal.text' />
			</div>
		</div>
	</BaseModal>
);
export default SubscriptionSuccessfulCancellationModal;
